import styled from '@emotion/styled';
import Dialog from '../dialog/dialog';
import { gutterSizes } from '../base/theme';

export const ModalDialog = styled(Dialog)`
    max-width: unset;
`;

export const MapsContainer = styled.div`
    padding-top: ${gutterSizes.xxlarge};
`;

export const StyledIFrame = styled.iframe`
    display: block;
    border: 0;
`;

export const OverlapContainer = styled.div<{ height: string }>`
    ${({ height }) => `
        height: ${height};
        background: transparent;
        position: relative;
        top: -${height};
        margin-bottom: -${height};
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        svg {
            height: 100%;
            width: 100%;
        }
    `}
`;
